module.exports = __webpack_public_path__ + "img/empty_blank.c67570e2.svg";